import { ConfirmDialog } from "@nymbl/nos2-rules";
import { useAskCancel } from "@/hooks/use-pto";
import { PTO_NOTE_MAX } from "@/lib/pto/constants";
import type { MyRequest } from "@/lib/pto/my-requests";
import { formatDateRange } from "@/lib/team/pto-list";

/**
 * Started time off: the approver decides (D2). A reason is required. A failed send keeps the
 * dialog open; a retry after a 504 is settled from the request's real state (`useAskCancel`).
 */
export function AskCancelDialog({
  request,
  onClose,
}: {
  request: MyRequest | null;
  onClose: () => void;
}) {
  const ask = useAskCancel();
  return (
    <ConfirmDialog
      open={request !== null}
      onOpenChange={(open) => !open && !ask.isPending && onClose()}
      title="Ask to cancel"
      description={request ? formatDateRange(request.startDate, request.endDate) : ""}
      confirmLabel="Send"
      loading={ask.isPending}
      reason={{ label: "Reason", maxLength: PTO_NOTE_MAX }}
      onConfirm={(note) => {
        if (request) ask.mutate({ id: request.id, note }, { onSuccess: onClose });
      }}
    />
  );
}
